import { omit } from 'lodash/fp';
import PropTypes from 'prop-types';
import React from 'react';
import Table from 'components/shared/table';
import { AssociatedContent } from '../../../AssociatedContent/types';
import * as types from '../../types';
import ShowMore from '../ShowMore';
import UnregisteredRow from './UnregisteredRow';

const Unregistered = ({
  addGuest,
  associatedContent,
  attendanceErrors,
  event,
  loading,
  onShowMore,
  query,
  unregistered,
}) => {
  return (
    <div className="AttendanceTableSection">
      <h4 className="AttendanceTableSection-header mt-16">
        {t('in_person_training.event_overview.attendance.everyone_else_title', {
          count: unregistered.searchCount,
        })}
      </h4>
      {!unregistered.data.length && (
        <div className="AttendanceTableSection-placeholder">
          {loading
            ? t('common.loading')
            : t(
                'in_person_training.event_overview.attendance.no_results_for_query',
                { query },
              )}
        </div>
      )}
      {!!unregistered.data.length && (
        <Table alternate>
          {unregistered.data.map(user => (
            <UnregisteredRow
              addGuest={addGuest}
              attendanceErrors={attendanceErrors}
              key={user.id}
              user={user}
              event={event}
              associatedContent={associatedContent}
            />
          ))}
          <ShowMore
            onClick={onShowMore}
            filter={omit('data', unregistered)}
            currentTotal={unregistered.data.length}
          />
        </Table>
      )}
    </div>
  );
};

Unregistered.propTypes = {
  addGuest: PropTypes.func.isRequired,
  associatedContent: AssociatedContent,
  attendanceErrors: PropTypes.shape({}),
  event: types.Event,
  loading: PropTypes.bool,
  onShowMore: PropTypes.func,
  query: PropTypes.string,
  unregistered: types.UnregisteredAttendances,
};

export default Unregistered;
